import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import * as styles from './TaxModal.module.scss'

import { Modal } from '../../basics/Modal'
import { getTaxVariant } from '../../contents/Tax/utils'

type TaxModalProps = {
  isOpen: boolean
  showAccommodationTax: boolean
  showBathTax: boolean
  onClose: () => void
}

const titleKeyByVariant = {
  accommodation: 'accommodationTitle',
  bath: 'bathingTitle',
  both: 'accommodationAndBathingTitle',
} as const

export const TaxModal: React.FC<TaxModalProps> = ({
  isOpen,
  showAccommodationTax,
  showBathTax,
  onClose,
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'components.TaxModal',
  })
  const variant = getTaxVariant(showAccommodationTax, showBathTax)

  const title = useMemo(() => {
    if (!variant) {
      return ''
    }

    return t(titleKeyByVariant[variant])
  }, [t, variant])

  if (!variant) {
    return null
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title}>
      <div className={styles.content}>
        {showAccommodationTax && (
          <section className={styles.section}>
            <h3 className={styles.heading}>{t('accommodationTitle')}</h3>
            <p>{t('accommodationText')}</p>
            <div className={styles.detail}>
              <h4 className={styles.detailHeading}>{t('detail')}</h4>
              <p>{t('accommodationDetail')}</p>
            </div>
          </section>
        )}
        {showBathTax && (
          <section className={styles.section}>
            <h3 className={styles.heading}>{t('bathingTitle')}</h3>
            <p>{t('bathingText')}</p>
            <div className={styles.detail}>
              <h4 className={styles.detailHeading}>{t('detail')}</h4>
              <p>{t('bathingDetail')}</p>
            </div>
          </section>
        )}
      </div>
    </Modal>
  )
}
